import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import {
  deleteReceivedPayment,
  getAllAccountReceivables,
  selectReceivablePaymentForDeletion,
  selectState,
  setIndexesForPaymentDeletion,
} from "../accountReceivable.slice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { selectPartner } from "../../Main/main.slice";
import { FormatDate } from "utils/dateUtils";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";

const DeleteReceivedPaymentModal = () => {
  const dispatch = useAppDispatch();
  const { deleteReceivedPaymentModalOpen } = useSelector(selectState);
  const data = useSelector(selectReceivablePaymentForDeletion);
  const partner = useSelector(selectPartner);

  const close = () => {
    dispatch(setIndexesForPaymentDeletion(undefined));
  };

  const doDelete = async () => {
    try {
      if (data) {
        await dispatch(deleteReceivedPayment(data?.payment.receivedPaymentId)).unwrap();
        dispatch(getAllAccountReceivables(partner.partnerId));
        toast.success("Uplata je uspešno obrisana.");
        close();
      }
    } catch (status: any) {
      close();
      if (status === 404) {
        toast.error("Uplata koju tražite da se obriše ne postoji");
      } else if (status === 400) {
        toast.error("Brisanje nije moguće zbog neočekivane greške");
      }
    }
  };

  return (
    <Modal
      isOpen={deleteReceivedPaymentModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje uplate"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeću uplatu?
        <br />
        <br />
        <b>
          Br. fakture - {data && data.reference}
          <br />
          Datum - {data && FormatDate(data.payment.date)}
          <br />
          Iznos - {FormatNumberWithUnitOrNull(data?.payment.amount, 'rsd')}
        </b>
      </p>
    </Modal>
  );
};

export default DeleteReceivedPaymentModal;
